import { ErrorTypes } from '@wix/form-validator';
import { SupportedDateParts } from '../../utils/date-format-parts';
import { deserializeDate } from '../date-picker/helpers';
export var DateFieldErrorSuffix = /*#__PURE__*/ function(DateFieldErrorSuffix) {
    DateFieldErrorSuffix["YEAR_MONTH"] = "year-month";
    DateFieldErrorSuffix["YEAR_DAY"] = "year-day";
    DateFieldErrorSuffix["MONTH_DAY"] = "month-day";
    DateFieldErrorSuffix["YEAR"] = "year";
    DateFieldErrorSuffix["MONTH"] = "month";
    DateFieldErrorSuffix["DAY"] = "day";
    return DateFieldErrorSuffix;
}({});
export const getDateFieldError = (_validation, error, value)=>{
    const isFormatError = error?.errorType === ErrorTypes.FORMAT_ERROR;
    if (!error || !isFormatError) {
        return error;
    }
    const { YEAR: _YEAR, MONTH, DAY } = deserializeDate(value);
    const YEAR = _YEAR?.length === 4;
    // All missing is the error we got as input
    if (!YEAR && !MONTH && !DAY) {
        return error;
    }
    const withErrorSuffix = (suffix)=>({
            ...error,
            errorType: ErrorTypes.INCOMPLETE_DATE_ERROR,
            params: {
                suffix
            }
        });
    if (!YEAR && !MONTH) {
        return withErrorSuffix("year-month");
    }
    if (!YEAR && !DAY) {
        return withErrorSuffix("year-day");
    }
    if (!MONTH && !DAY) {
        return withErrorSuffix("month-day");
    }
    if (!YEAR) {
        return withErrorSuffix("year");
    }
    if (!MONTH) {
        return withErrorSuffix("month");
    }
    if (!DAY) {
        return withErrorSuffix("day");
    }
    return error;
};
export const getDatePartsErrors = (hasError, value)=>{
    const { YEAR, MONTH, DAY } = deserializeDate(value);
    const invalidParts = [
        YEAR?.length !== 4,
        !MONTH,
        !DAY
    ];
    const allValidParts = !invalidParts.some(Boolean);
    return {
        [SupportedDateParts.YEAR]: hasError && (allValidParts || invalidParts[0]),
        [SupportedDateParts.MONTH]: hasError && (allValidParts || invalidParts[1]),
        [SupportedDateParts.DAY]: hasError && (allValidParts || invalidParts[2])
    };
};
const isDateFieldValidationError = (error)=>{
    return error?.errorType === ErrorTypes.INCOMPLETE_DATE_ERROR;
};
export const getDateValidationErrorSuffix = (error)=>isDateFieldValidationError(error) ? error.params.suffix : undefined;

//# sourceMappingURL=date-field-utils.js.map